export default {
    path: '/billlist',
    meta: {
        title: '账单',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/billlist`),
}


// WEBPACK FOOTER //
// ./src/views/BillList/router.js